import TextAreaField from './TextAreaAdapter';
export { TextAreaField as default };
